import React from "react";

import { FAST_FILTERS_CONFIG } from "./options";

import styles from "./FilterSummary.less";

interface FastFilterIProps {
  fastItem: "day" | "week" | "month" | null;
  applyFastFilter: (
    getRange: () => [Date, Date],
    newFastItem: "day" | "week" | "month",
  ) => void;
}

const FastFilter = ({ applyFastFilter, fastItem }: FastFilterIProps) => {
  return (
    <div className={styles.fastFilter}>
      {FAST_FILTERS_CONFIG.map((filter) => (
        <span
          key={filter.label}
          onClick={() => applyFastFilter(filter.getRange, filter.name)}
          className={
            fastItem === filter.name
              ? styles.activeFastFilter
              : styles.defaultFastFilter
          }
        >
          {filter.label}
        </span>
      ))}
    </div>
  );
};

export default FastFilter;
